"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPreviousPlacementDetailsDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
class OpportunityPreviousPlacementDetailsDto {
}
exports.OpportunityPreviousPlacementDetailsDto = OpportunityPreviousPlacementDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Details about challenges and mitigation strategies",
        example: "High competition mitigated by offering better pricing.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Challenges and Mitigation must be a valid string" }),
    tslib_1.__metadata("design:type", String)
], OpportunityPreviousPlacementDetailsDto.prototype, "challengesAndMitigation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Details about existing competition",
        example: "Competitor A and Competitor B are active in this region.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Existing Competition must be a valid string" }),
    tslib_1.__metadata("design:type", String)
], OpportunityPreviousPlacementDetailsDto.prototype, "existingCompetition", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Additional remarks or comments",
        example: "Client prefers a long-term policy.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a valid string" }),
    tslib_1.__metadata("design:type", String)
], OpportunityPreviousPlacementDetailsDto.prototype, "remarks", void 0);
